var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        'input-wrap-container',
        {
            error: _vm.isError,
        },
    ]},[_c('div',{staticClass:"input-wrap"},[(_vm.label)?_c('label',{staticClass:"label",attrs:{"for":_vm.id}},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.validation && _vm.validation.required !== undefined)?_c('span',{staticClass:"is-required"},[_vm._v(" * ")]):_vm._e()]):_vm._e(),_c('textarea',{class:['input', `input-textarea`],attrs:{"id":_vm.id,"name":_vm.id,"placeholder":_vm.placeholder,"rows":_vm.rows},domProps:{"value":_vm.value},on:{"input":_vm.updateValue,"blur":_vm.handleBlur}})]),(_vm.isError)?_c('ErrorMessages',{staticClass:"error-message-wrap",attrs:{"label":_vm.label,"validation":_vm.validation}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }